<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <label class="h5">Depositario Provisional</label>
      </header>
      <form
        [formGroup]="formDatos"
        (ngSubmit)="getRnt(formDatos.value.codigo_rnt)"
      >
        <div class="form-group">
          <label class="small text-secondary" for="nit"
            >Ingrese el número de RNT</label
          >
          <input
            formControlName="codigo_rnt"
            id="codigo_rnt"
            type="text"
            class="form-control form-control-sm"
          />
        </div>
        <div class="form-row mt-5">
          <button
            class="btn btn-primary m-auto"
            [disabled]="!formDatos.valid"
            type="submit"
          >
            Buscar
          </button>
        </div>
      </form>
    </section>
    <section
      class="col-9 p-4 mt-5 mb-5"
      *ngIf="informacionEstablecimiento; else no_data"
    >
      <section class="row mb-4 pl-2">
        <section class="col-12 mb-4 mt-4 border-bottom">
          <footer class="row">
            <h2 class="col-9 h5 font-weight-bold mb-2">Datos del prestador</h2>
            <p class="col-3 small">
              Última actualización:
              <strong>{{
                informacionEstablecimiento.fecha_ultima_actualizacion
                  | date: "d/MMM/yyyy"
              }}</strong>
            </p>
            <ng-container
              *ngIf="informacionEstablecimiento.tipo_rnt_id !== 2; else es_guia"
            >
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Representante legal</label>
                <p>
                  <strong>{{
                    informacionEstablecimiento.nombre_representante_legal
                  }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Número identificación</label>
                <p>
                  <strong>{{
                    informacionEstablecimiento.numero_identificacion_representante_legal
                  }}</strong>
                </p>
              </div>
            </ng-container>
            <ng-template #es_guia>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Número identificación</label>
                <p>
                  <strong>{{
                    informacionEstablecimiento.numero_identificacion
                  }}</strong>
                </p>
              </div>
            </ng-template>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Patrimonio neto</label>
              <p>
                <strong>{{
                  informacionEstablecimiento.patrimonio_neto | currency: "COP"
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Número de empleados</label>
              <p>
                <strong>{{
                  informacionEstablecimiento.numero_empleados
                }}</strong>
              </p>
            </div>
          </footer>
        </section>
        <section class="col-12 mb-4 mt-1 border-bottom">
          <footer class="row">
            <!-- Establecimiento -->
            <ng-container *ngIf="informacionEstablecimiento.tipo_rnt_id == 1">
              <h2 class="col-12 h5 font-weight-bold mb-2">
                Datos del establecimiento
              </h2>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Nombre</label>
                <p>
                  <strong>{{ informacionEstablecimiento.razon_social }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Matrícula mercantíl</label>
                <p>
                  <strong>{{ informacionEstablecimiento.matricula }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Último año renovado</label>
                <p>
                  <strong>{{
                    informacionEstablecimiento.ultimo_anio_renovado
                  }}</strong>
                </p>
              </div>
            </ng-container>
            <!-- Inmueble -->
            <ng-container *ngIf="informacionEstablecimiento.tipo_rnt_id == 3">
              <h2 class="col-12 h5 font-weight-bold mb-2">
                Datos del inmueble
              </h2>
            </ng-container>
            <!-- Guia -->
            <ng-container *ngIf="informacionEstablecimiento.tipo_rnt_id == 2">
              <h2 class="col-12 h5 font-weight-bold mb-2">Datos del guía</h2>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Nombre de guia</label>
                <p>
                  <strong>{{
                    informacionEstablecimiento.nombre_gerente
                  }}</strong>
                </p>
              </div>
            </ng-container>
            <!-- Datos generales -->
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Último año renovado RNT</label>
              <p>
                <strong>{{
                  informacionEstablecimiento.ultimo_anio_renovado_rnt
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Dirección</label>
              <p>
                <strong>{{
                  informacionEstablecimiento.direccion_comercial
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Departamento</label>
              <p>
                <strong>{{ informacionEstablecimiento.departamento }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Municipio</label>
              <p>
                <strong>{{ informacionEstablecimiento.municipio }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Cámara de comercio</label>
              <p>
                <strong>{{
                  informacionEstablecimiento.desc_camara_largo
                }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Categoría</label>
              <p>
                <strong>{{ informacionEstablecimiento.categoria }}</strong>
              </p>
            </div>
            <div class="col-sm-12 col-md-3">
              <label class="small mb-0">Sub categoría</label>
              <p>
                <strong>{{ informacionEstablecimiento.subcategoria }}</strong>
              </p>
            </div>
          </footer>
        </section>
        <section class="col-12 mt-1">
          <footer class="row">
            <ng-container
              *ngIf="
                informacionEstablecimiento.usuario_depositario_id !== null;
                else no_depositario
              "
            >
              <h2 class="col-12 h5 font-weight-bold mb-2">
                Datos del depositario provisional
              </h2>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Nombre</label>
                <p>
                  <strong>{{
                    informacionEstablecimiento.nombre_usuario_depositario +
                      " " +
                      informacionEstablecimiento.apellido_usuario_depositario
                  }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Correo</label>
                <p>
                  <strong class="overflow-wrap-break-word">{{
                    informacionEstablecimiento.correo_electronico_usuario_depositario
                  }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-3">
                <label class="small mb-0">Cargo</label>
                <p>
                  <strong>{{
                    informacionEstablecimiento.cargo_usuario_depositario
                  }}</strong>
                </p>
              </div>
              <div class="col-sm-12 col-md-3 centrar-boton">
                <button
                  class="btn btn-primary paso-capacidad"
                  (click)="openModalEliminarDepositario()"
                >
                  Desasociar usuario depositario
                </button>
              </div>
            </ng-container>
            <ng-template #no_depositario>
              <div class="col-12 centrar-boton">
                <button
                  class="btn btn-primary paso-capacidad"
                  (click)="openModalAsignarDepositario()"
                >
                  Asignar usuario depositario
                </button>
              </div>
            </ng-template>
          </footer>
        </section>
      </section>
    </section>
    <ng-template #no_data>
      <section class="col-9 p-4 mt-5 mb-5">
        <header class="col-12">
          <figure class="figure w-100 text-center">
            <img
              class="img-fluid mb-4"
              src="../../../../../../../assets/images/sin_establecimiento.png"
            />
            <figcaption>
              <label class="h3">No hay información</label>
            </figcaption>
          </figure>
        </header>
      </section>
    </ng-template>
  </article>
</main>
